"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreJsonMapper = void 0;
const json_schema_1 = require("../../json-schema");
const timestamp_json_1 = require("../timestamp-json");
const core_model_1 = require("./core-model");
const isCoreItem = (0, json_schema_1.createValidator)(core_model_1.CoreJson);
function attendeeFromJson(item, mode) {
    if (isCoreItem(item)) {
        return {
            ...timestamp_json_1.TimestampsJsonMapper.fromJSON('createdAt' in item ? item : {}),
            id: item.id,
            fixedFlag: item.fixedFlag,
            name: item.name,
            componentID: item.componentID,
            componentFieldData: item.componentFieldData,
            variables: item.variables,
            adminUI: item.adminUI,
            coreType: item.coreType,
        };
    }
    else if (mode === 'data-only') {
        return undefined;
    }
    else {
        return isCoreItem.errors ?? [];
    }
}
/**
 * Create a JSON representation of a `Core`.
 * @param record to convert to JSON
 * @returns a JSON represenation of `Core`.
 */
function attendeeToJson(record) {
    return {
        ...timestamp_json_1.TimestampsJsonMapper.toJSON(record),
        id: record.id,
        fixedFlag: record.fixedFlag,
        name: record.name,
        componentID: record.componentID,
        componentFieldData: record.componentFieldData,
        variables: record.variables,
        adminUI: record.adminUI,
        coreType: record.coreType,
    };
}
exports.CoreJsonMapper = {
    fromJSON: attendeeFromJson,
    toJSON: attendeeToJson,
};
